module.exports = __webpack_public_path__ + "static/media/orange-star.130f7419.svg";